import { tap } from 'lodash/fp';
import AnalyticsConstants from '../analytics/constants';
import {
  createAndSendButtonSubmissionAnalyticsEventForSingleSku,
} from '../analytics/commonAnalytics';
import estimateLoaded from './estimateLoaded';
import loading from './loading';
import loaded from './loaded';
import { deleteItem, deleteProduct } from '../api/designBuilder';
import globalError from './globalError';

export default (designId, itemId) => (dispatch, getState) => {
  dispatch(loading());
  const { items } = getState().estimateBuilder.entities;

  const itemIds = items.allIds.reduce((result, id) => {
    if (items.byId[id].designId === designId) {
      result.push(items.byId[id]);
    }

    return result;
  }, []);

  let apiMethod = deleteProduct;

  if (itemIds.length > 1) {
    apiMethod = deleteItem;
  }

  return apiMethod(designId, itemId)
    .then((response) => {
      const skuNumber = items.byId[itemId].itemProduct
        ? items.byId[itemId].itemProduct.skuNumber
        : null;

      createAndSendButtonSubmissionAnalyticsEventForSingleSku(
        window.globalConfig.siteId,
        skuNumber,
        AnalyticsConstants.EventNames.DesignRemoveProduct,
      );

      dispatch(estimateLoaded(response.data));
      return this;
    })
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
};
